import {useLocalStorage} from '~ui/hooks';

export function useEditorDraft(slug?: string, postfix?: string) {
    const draftKey = `${slug}-draft${postfix ? `-${postfix}` : ''}`;
    const [draft, setDraft, removeDraft] = useLocalStorage<undefined | string>(draftKey);

    return {draft, setDraft, removeDraft};
}
